import {QueryResult} from "@apollo/client/react/types/types";
import { VALIDATE_ADVERTISING_SUPPORTED_QUERY } from "../atoms/Queries";
import {OperationVariables, useQuery} from "@apollo/client";
import { useMember } from "./useMember";
import { findKeyByValue } from "../enums/FindKeyByValue";
import { State } from "../enums/State";

export function useAdvertising(): QueryResult {
    const { loading: memberLoading, data: memberData, error: memberError } = useMember();

    const contractState = findKeyByValue(State, memberData?.benefit?.contractState)

    const {
        loading: advertisingLoading,
        data: advertisingData,
        error: advertisingError,
        ...advertisingProps
    } = useQuery(VALIDATE_ADVERTISING_SUPPORTED_QUERY, {
        variables: {
            contractState
        } as OperationVariables,
        skip: !contractState
    })

    return {
        ...advertisingProps,
        loading: advertisingLoading || memberLoading,
        data: advertisingData?.validateAdvertisingSupported,
        error: advertisingError || memberError
    }
}
